import { render, staticRenderFns } from "./NewUiNav.vue?vue&type=template&id=043064a6&scoped=true"
import script from "./NewUiNav.vue?vue&type=script&lang=js"
export * from "./NewUiNav.vue?vue&type=script&lang=js"
import style0 from "./NewUiNav.vue?vue&type=style&index=0&id=043064a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043064a6",
  null
  
)

export default component.exports